import React from 'react'

function Kanban() {
  return (
    <div>Kanban</div>
  )
}

export default Kanban